import "../styles/auth-flow.css";

interface Props {
  label: string;
}

// Full-screen blocking overlay shown while the browser is being handed over to
// Salesforce. It covers everything (camera frame, fallback links, cancel) so no second
// capture or action can start during the hand-off; the screens re-enable themselves if
// the redirect turns out to have failed (see useExternalRedirect).
export function RedirectOverlay({ label }: Props) {
  return (
    <div className="redirect-overlay" role="status" aria-live="polite">
      <span className="redirect-overlay-spinner" aria-hidden="true">
        {Array.from({ length: 8 }).map((_, i) => (
          <span key={i} style={{ transform: `rotate(${i * 45}deg)`, opacity: (i + 1) / 8 }} />
        ))}
      </span>
      <span className="redirect-overlay-label">{label}</span>
    </div>
  );
}
